// ML001-F0252..F0255 (monthly draft cycle, WebUI #170). The customer's operations through Core's Service Link Pass-through relay (CSLPT):
// POST /api/v1/orgs/:orgId/modules/ledger/messages with the closed envelope { relay_version: 1, type, payload, target_user_id? }.
// Shapes follow Core's manifest (core-agw112 src/services/serviceLinkPassthrough/cslptManifest.ts) and Spec core-ledger-account-gateway 1.12.0
// (pinned under tests/ledger-account-gateway, digest be1636d0).
//   - target_user_id: an INTEGER (the envelope's identity member). Absent means the caller; naming another customer needs ledger_manage at SAL 4.
//   - payload: the operation body, forwarded unread. advice.current has no body and sends {}.
//   - draft.customer_issue / draft.not_happy: the body is the Spec DraftCustomerIssueBody / DraftNotHappyBody.
//   - transaction.advance: the body is { hand_off_id } (the Spec TransactionAdvanceBody; the HTTP surface names it in the path).
// Customer operations carry no Idempotency-Key (manifest idempotency: none); the draft version or item id is the guard.
// Answers: Core relays the Ledger's tunnel payload as data.payload (advice.current: { cycle, user_id, items }; the writes: invoice_id and status / attention / hand_off_id).
import api from './api';

const messagesPath = (orgId) => `/v1/orgs/${encodeURIComponent(orgId)}/modules/ledger/messages`;
const envelope = (type, payload, targetUserId) => ({
  relay_version: 1, type, payload, ...(targetUserId !== undefined ? { target_user_id: Number(targetUserId) } : {}),
});

// Relay answers { success, data: { payload } }; the operation's own answer is `payload`.
const payloadOf = (response) => response?.data?.data?.payload ?? null;

export const monthlyCycleApi = {
  // draft.customer_get (Spec 1.12.0 final, Spec main 3f14499a): the customer's one open draft with Draft.version; draft is null when there is none.
  // A read: payload {} and no key. Answer: { binding_generation, draft }.
  // invoiceId: the selector for a customer with more than one open draft (design §9.2); omitted for one draft.
  draftCustomerGet: async (orgId, userId, { invoiceId } = {}) => payloadOf(await api.post(messagesPath(orgId), envelope('draft.customer_get', invoiceId ? { invoice_id: invoiceId } : {}, userId))),
  adviceCurrent: async (orgId, userId) => payloadOf(await api.post(messagesPath(orgId), envelope('advice.current', {}, userId))),
  customerIssue: (orgId, userId, expectedVersion, { invoiceId } = {}) => api.post(
    messagesPath(orgId),
    envelope('draft.customer_issue', { expected_version: expectedVersion, ...(invoiceId ? { invoice_id: invoiceId } : {}) }, userId),
  ),
  notHappy: (orgId, userId, expectedVersion, message, { invoiceId } = {}) => api.post(
    messagesPath(orgId),
    envelope('draft.not_happy', { expected_version: expectedVersion, message, ...(invoiceId ? { invoice_id: invoiceId } : {}) }, userId),
  ),
  advance: (orgId, userId, handOffId) => api.post(
    messagesPath(orgId),
    envelope('transaction.advance', { hand_off_id: handOffId }, userId),
  ),
};
